import { useConfirmStore } from "../store/confirm-store";

export const ConfirmModal = () => {
  const { isOpen, message, onConfirm, closeConfirm } = useConfirmStore();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm">
      <div className="bg-white rounded-lg shadow-2xl p-6 w-96">
        <p className="text-gray-800 text-sm mb-4">{message}</p>
        <div className="flex justify-end gap-2">
          <button
            onClick={closeConfirm}
            className="px-4 py-2 text-sm text-gray-600 hover:text-gray-900"
          >
            Cancel
          </button>
          <button
            onClick={() => {
              onConfirm();
              closeConfirm();
            }}
            className="rounded-lg bg-black text-white px-4 py-2 hover:bg-gray-800 disabled:opacity-60"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};
